import {
  GridCellProps,
  GridColumnMenuCheckboxFilter,
  GridColumnMenuProps,
} from "@progress/kendo-react-grid";
import { EnumerationCell } from "../../../Layout/Grid/Cell/Default/EnumCell";
import { bidPackStateAsStringFirstLetter, BidPackStateStringValue } from "../BidPackState";
import { transportTypeAsString, TransportTypesStringValue } from "../TransportTypes";

export const bidPackTransportTypeEnumCell = (props: GridCellProps) => (
  <EnumerationCell {...props} mapping={transportTypeAsString} />
);

export const bidPackTransportTypeColumnMenu = (props: GridColumnMenuProps) => (
  <GridColumnMenuCheckboxFilter
    expanded
    filterable
    data={[
      { TransportType: TransportTypesStringValue.LTL },
      { TransportType: TransportTypesStringValue.FTL },
      { TransportType: TransportTypesStringValue.Rail },
      { TransportType: TransportTypesStringValue.JitKanban },
    ]}
    searchBox={() => null}
    {...props}
  />
);

export const bidPackRateAgreementStateEnumCell = (props: GridCellProps) => (
  <EnumerationCell {...props} mapping={bidPackStateAsStringFirstLetter} />
);

export const bidPackRateAgreementStateColumnMenu = (props: GridColumnMenuProps) => (
  <GridColumnMenuCheckboxFilter
    expanded
    filterable
    data={[
      { RateAgreementStatus: BidPackStateStringValue.Active },
      { RateAgreementStatus: BidPackStateStringValue.Pending },
      { RateAgreementStatus: BidPackStateStringValue.Expired },
      { RateAgreementStatus: BidPackStateStringValue.New },
    ]}
    searchBox={() => null}
    {...props}
  />
);
